import request, { requestSet, METHOD } from '@/utils/request'

 // 日生产计划信息搜索(成品)
  export function apiFinishProductSearchList (query) {
    return request({
      url: `/scp/scpProductionScheduling/finishProductSearch`,
      method: 'get',
      params: query
    })
  }
 // 日生产计划信息搜索(零部件品)
 export function apiLjProductSearchList (query) {
  return request({
    url: `/scp/scpProductionScheduling/ljProductSearch`,
    method: 'get',
    params: query
  })
}
 // 供应商与零部件对应关系
 export function apiProductionSchedulingSearch (query) {
  return request({
    url: `/scp/scpProductionScheduling/dySearch`,
    method: 'get',
    params: query
  })
}
 // 新增供应商与零部件对应关系
 export function apiAddProductionScheduling (data) {
  return request({
    url: `/scp/scpProductionScheduling/dyadd`,
    method: 'post',
    data: data
  })
}
 // 更新供应商与零部件对应关系
 export function apiUpdateProductionScheduling (query) {
  return request({
    url: `/scp/scpProductionScheduling/dyUpdate`,
    method: 'post',
    data: query

  })
}
 // 供应商下拉接口
 export function apiUpdateProductionSchedulinglistfdxiala (query) {
  return request({
    url: `/scp/scpProductionScheduling/listfdxiala`,
    method: 'get',
    params: query
  })
}
 // 零件类型下拉接口
 export function apiUpdateProductionSchedulingsearchljtype (query) {
  return request({
    url: `/scp/scpProductionScheduling/searchljtype`,
    method: 'get',
    params: query
  })
}

 // 重新拆解接口
 export function apiScpProductionSchedulingDisassembly (query) {
  return request({
    url: `/scp/scpProductionScheduling/disassembly`,
    method: 'get',
    params: query
  })
}

// 重新拆解接口(勾选数据)
export function apiScpProductionSchedulingDisassembly2 (data) {
  return request({
    url: `/scp/scpProductionScheduling/disassembly2`,
    method: 'post',
    data: data
  })
}

// 日生产计划信息删除
export function apiScpDelfinishProduct (data) {
  return request({
    url: `/scp/scpProductionScheduling/delfinishProduct`,
    method: 'post',
    data: data
  })
}

// 日生产计划信息修改(成品)
export function apiScpProductionSchedulingFinishProductUpdate (data) {
  return request({
    url: `/scp/scpProductionScheduling/finishProductUpdate`,
    method: 'post',
    data: data
  })
}

/**
 * 导入
 * @returns {Promise<AxiosResponse<T>}
 */
export async function apiFinishProductImport(params) {
  return requestSet(`/scp/scpProductionScheduling/finishProductImport?updateSupport=0`, METHOD.POST, params, { responseType: "blob" });
}

// 日生产计划信息修改(零部件)
export function apiScpProductionSchedulingLjProductUpdate (data) {
  return request({
    url: `/scp/scpProductionScheduling/ljProductUpdate`,
    method: 'post',
    data: data
  })
}

// 触发定时任务"签价BOM同步"
export function apiMdmGetSignBom (data) {
  return request({
    url: '/external/plm/getSignBom',
    method: 'post',
    data: data
  })
}

// 手动物料同步
export function apiManualSyncMaterial (data) {
  return request({
    url: '/external/plm/manualSyncMaterial',
    method: 'post',
    data: data
  })
}
